export default __webpack_public_path__ + "static/media/services-audit-e-reputation.a11c7cc5.svg";